export const DLinkMenuItemId = wcardinal.ui.DLinkMenuItemId;